import type { Locale } from '@/root/shared-types'

export const localeFormats: Record<Locale, string> = {
  en: 'en-US',
  ar: 'ar',
  es: 'es-ES',
  et: 'et-EE',
}
